module.exports = __webpack_public_path__ + "img/event-template1.451cee21.jpg";